export class SignUpFailedManyTimesException extends Error {
}

export default {
  SignUpFailedManyTimesException
}
